import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))

    if (data) {
        let headers = {
            Authorization: `Bearer ${token}`,
        };

        // If data is NOT FormData, set Content-Type to application/json
        if (!(data instanceof FormData)) {
            headers['Content-Type'] = 'application/json';
        }
        const requestOptions = {
            method: method,
            headers: headers,
            body: data instanceof FormData ? data : JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
        };
        return requestOptions
    }

}

export const orderListingApi = async (payload) => {
    const request = requestAuthOption("GET");
    let status = '';
    let doctor_id = '';

    if (payload?.status?.length > 0) {
        status = payload?.status?.map(id => `status[]=${encodeURIComponent(id)}`).join('&') || '';
    }
    if (payload?.doctor_id?.length > 0) {
        doctor_id = payload?.doctor_id?.map(id => `doctor_id[]=${encodeURIComponent(id)}`).join('&') || '';
    }
    
    try {
        const response = await fetch(
            `${server}orders?paginate=${payload?.page}&size=${payload?.length}&search=${payload?.search}${status ? `&${status}` : ''}${doctor_id ? `&${doctor_id}` : ''}${payload?.date_filter && payload?.date_filter !== 'custom' ? `&date_filter=${payload?.date_filter}` : ''}${payload?.start_date && payload?.end_date ? `&start=${payload?.start_date}&end=${payload?.end_date}` : ''}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const orderDetailsApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}order/${payload?.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data?.data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const orderUpdateStatusApi = async (payload) => {
    const request = requestAuthOption("POST", payload?.data)
    try {
        const response = await fetch(
            `${server}order/${payload?.id}/${payload?.status}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};


export const exportOrderApi = async (payload) => {
    const request = requestAuthOption("GET");
    let status = '';
    let doctor_id = '';

    if (payload?.status?.length > 0) {
        status = payload?.status?.map(id => `status[]=${encodeURIComponent(id)}`).join('&') || '';
    }
    if (payload?.doctor_id?.length > 0) {
        doctor_id = payload?.doctor_id?.map(id => `doctor_id[]=${encodeURIComponent(id)}`).join('&') || '';
    }

    try {
        const response = await fetch(
            `${server}orders/export?search=${payload?.search || ''}${payload?.date_filter && payload?.date_filter !== 'custom' ? `&date_filter=${payload?.date_filter}` : ''}${payload?.start_date && payload?.end_date ? `&start=${payload?.start_date}&end=${payload?.end_date}` : ''}&response_type=json&base64=true${status ? `&${status}` : ''}${doctor_id ? `&${doctor_id}` : ''}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};

export const exportOrderDetailsApi = async (payload) => {
    const request = requestAuthOption("GET");
    try {
        const response = await fetch(
            `${server}order/${payload?.id}/print?response_type=json`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // throw error;
            })
        })
    }
};
